import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { Modal as AntModal } from 'components/atoms/modal';
import { useTaskDrawerQueryParamsFromRouter } from 'hooks/use-query-params';
import { queryClient } from 'queries';
import { useTaskDetailQuery } from 'queries/task';
import { CustomerPortalTaskDrawer } from './task-drawer/cp-task-drawer';

const Modal = styled(AntModal)`
  .ant-modal-body {
    height: 90svh;
    padding: 0;
  }
  .ant-modal-footer {
    display: none;
  }

  .ant-modal-close {
    z-index: 1000000;
  }

  /* set overflow hiiden to parent .ant-modal-wrap */
  .ant-modal-wrap,
  & ~,
  & ~ .ant-modal-wrap {
    overflow: hidden;
  }

  @media (max-width: 768px) {
    top: 0;

    .ant-modal-body {
      height: 95svh;
    }
  }

  @media (max-width: 486px) {
    top: var(--cp-spacing-05);
    .ant-modal-body {
      height: 95svh;
    }
  }
`;

const StyledOutsideClickHandler = styled.div`
  height: 100%;
`;

export const CpTaskModalWrapper: React.FC = () => {
  const {
    taskDrawer: { taskId, projectId },
    closeModal,
  } = useTaskDrawerQueryParamsFromRouter();

  const { data: task, refetch } = useTaskDetailQuery(
    ['task_id', projectId ?? -1, taskId ?? -1],
    {
      enabled: !!(taskId && projectId) && taskId !== -1 && projectId !== -1,
    },
  );

  const onClose = useCallback(() => {
    closeModal();
  }, [closeModal]);

  useEffect(() => {
    if (taskId && projectId) {
      refetch();
    }
  }, [taskId, projectId, refetch]);

  return (
    <Modal
      centered
      width="1248px"
      visible={!!(taskId && projectId)}
      onCancel={onClose}
      footer={<></>}
      getContainer={document.getElementById('cp-modal-root')}
      destroyOnClose
    >
      <StyledOutsideClickHandler>
        {task ? (
          <CustomerPortalTaskDrawer
            task={task}
            refetch={() => {
              refetch({ cancelRefetch: true });
              queryClient.refetchQueries({
                predicate: (query) => {
                  return (
                    ((query.queryHash.includes('PROJECT_PLAN') ||
                      query.queryHash.includes('PROJECT_TASKS_LIST')) &&
                      query.queryKey.includes('cp-render-input')) ||
                    query.queryKey.includes('document-tasks')
                  );
                },
              });
            }}
          />
        ) : (
          <></>
        )}
      </StyledOutsideClickHandler>
    </Modal>
  );
};
